<script lang="ts">
  import { getContext } from "svelte";
  import BtnControl from "./BtnControl.svelte";
  import { ConnectMapApp, type Floor } from "./app";

  const app = getContext<ConnectMapApp<any>>('app');
  const { floors, current_floor } = app;

  const select = (floor: Floor) => () => {
    if (collapsed) {
      focus = true;
    }
    else {
      app.setCurrentFloor(floor);
      focus = false;
    }
  };

  let focus = false;
  let style: (index: number) => string;

  // Could be done solely with CSS?
  // --_btn-outer-height, --_max + --_index per button
  const BTN_OUTER_HEIGHT = 44 + 8;
  const translate = (max: number, index: number) => (max - index) * BTN_OUTER_HEIGHT;
  const transform = (value: number) => `
    -webkit-transform: translateY(${value}px);
    transform: translateY(${value}px);
  `;

  $: collapsed = !focus;
  $: {
    const max = $floors.length - 1;
    style = collapsed
      ? index => transform(translate(max, index))
      : () => '';
  }

</script>

<div class="floor-ctrl compact"
  class:collapsed>
  <BtnControl class="stack-deco"></BtnControl>
  {#each $floors as floor, index}
    <BtnControl class={floor == $current_floor ? 'active' : ''} 
      on:click={select(floor)}
      style={style(index)}>{floor.short_name}</BtnControl>
  {/each}
</div>

<style lang="scss">
  .floor-ctrl {
    position: absolute;
    right: var(--_p2);
    bottom: var(--_p2);
    pointer-events: none;
    z-index: 20;

    :global(.stack-deco) {
      position: absolute;
      bottom: 0;
    }

    & > :global(button) {
      position: relative;
      width: 44px;
      height: 44px;
      margin: 8px 0 0 8px;
      pointer-events: all;
    }

    :global(button.active) {
      filter: invert(100%);
      z-index: 10;
    }

    &.compact {
      :global(button) {
        display: block;
        box-shadow: var(--vgwv-shadow-down);
        transition: all .3s;
        transition-timing-function: ease-out;
      }

      :global(.stack-deco) {
        opacity: 0;
        transition: all .2s;
        transition-timing-function: ease-out;
      }
    }

    /* In mobile buttons will be stacked */
    &.collapsed {

      & :global(button) {
        box-shadow: var(--vgwv-shadow-off);
      }

      & :global(.active) {
        filter: none;
      }

      & :global(.stack-deco) {
        box-shadow: var(--vgwv-shadow-down);
        opacity: 1;
        transform: translate(4px, 4px);
        transition-delay: .2s;
        transition-timing-function: ease-in;
      }
    }
  }



</style>